export const sources = {
	webp: "__VITE_ASSET__tgFyw$X211zXSctfMU9_LA__ 500w, __VITE_ASSET__nJkgIVJgL11RgZiGUBj6wA__ 800w, __VITE_ASSET__C$4kQWR6NkPB83QJdL0WCQ__ 1080w, __VITE_ASSET__9kBTUqaINCHDANxrI10WCw__ 1600w, __VITE_ASSET__479VhuutRPKqW_6Ht6iXzA__ 2000w"
};
export const img = {
	src: "__VITE_ASSET__479VhuutRPKqW_6Ht6iXzA__",
	w: 2000,
	h: 1333
};
export default {
	sources: sources,
	img: img
};
